export default __webpack_public_path__ + "static/media/gcreno.2d67adc0.png";